var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAlertHttp)?_c('alert-http',{attrs:{"error":_vm.error},on:{"close":function($event){return _vm.$emit('close', $event)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }